import { tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";
import Flex from "../../../layout/flex";

export const LoadingContainer = styled.div<{ $justifyContent?: "center" | "flex-start" }>`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: calc(100% - 32px);
  flex-direction: column;
  padding-top: ${(props) => (props.$justifyContent === "flex-start" ? "0px" : "80px")};
  align-items: center;
  text-align: center;
  padding-left: 8px;
`;

export const LoadingTextContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 ${tokens.spacing.xl};
  align-items: center;
  flex-direction: column;
  gap: ${tokens.spacing.s};
`;

export const TileContainer = styled(Flex)<{ $marginTop?: string }>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.$marginTop || "16px"};
  gap: 16px;
  .mds-account-tile {
    width: 100%;
  }
  .mds-option-tile[data-appearance="secondary"] {
    padding: 16px 24px;
    .mds-option-tile__inner {
      gap: 8px;
    }
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;
